import type { PartnerProgram } from "@/shared-types";

export interface VerificationUIConfigParams {
    isChat: boolean;
    programSelectionEnabled: boolean | undefined;
    programs: PartnerProgram[];
    useCustomerAgreementProgram: boolean;
    additionalVerificationFields: string[] | undefined;
    verificationType: "phoneNumber" | "billingAccountNumberAndPin";
    hasProducts: boolean;
}

export interface VerificationUIConfig {
    showProgramSelection: boolean;
    showAdditionalDetailsEmailInput: boolean;
    showAdditionalDetailsOrderIdInput: boolean;
    showAdditionalDetailsPhoneNumberInput: boolean;
}

/**
 * Computes the visibility flags for the verification UI based on partner config and context.
 */
export function computeVerificationUIConfig(params: VerificationUIConfigParams): VerificationUIConfig {
    const {
        isChat,
        programSelectionEnabled,
        programs,
        useCustomerAgreementProgram,
        additionalVerificationFields,
        verificationType,
        hasProducts,
    } = params;

    return {
        showProgramSelection:
            !isChat && !!programSelectionEnabled && programs.length > 1 && !useCustomerAgreementProgram,
        showAdditionalDetailsEmailInput: additionalVerificationFields?.includes("email") ?? false,
        showAdditionalDetailsOrderIdInput: additionalVerificationFields?.includes("orderId") ?? false,
        showAdditionalDetailsPhoneNumberInput: verificationType !== "phoneNumber" && hasProducts,
    };
}
